import React, { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';

// components
import { DropdownSelectComponent } from 'baseComponents/DropdownSelectComponent';
import { InputComponent } from 'baseComponents/InputComponent';

// styles
import './existingFilterGroup.scss';
import { AttributeType } from 'types/create-campaign';
import { getAttributeDisplayName } from 'helpers/create-audience';
import { parseOperatorLabel } from 'helpers/dropdown-data';

interface Props {
  filtersGroup: any;
  attributesList: AttributeType[];
}

export const ExistingFilterGroup: React.FC<Props> = (props) => {
  const fielduuid = useMemo(() => uuidv4(), []);

  const parseDisplayedValue = (item: any) => {
    const { custom_attribute } = item;
    if (custom_attribute.ui_presentation) {
      return custom_attribute.ui_presentation;
    }
    if (
      custom_attribute.value &&
      (custom_attribute.comparison === 'before' ||
        custom_attribute.comparison === 'after')
    ) {
      const date = dayjs.unix(custom_attribute.value);
      return date.format('YYYY-MM-DD HH:mm');
    }
    return custom_attribute.value;
  };
  return (
    <div className='existing-group-wrapper'>
      {props.filtersGroup?.map((item: any, index: number) => {
        if (item.hasOwnProperty('OR')) {
          return (
            <div className='filters' key={fielduuid + index}>
              <div className='existing-filter-group-wrapper'>
                {item.OR.map((filter: any, index: number) => (
                  <div className='existing-filter-row' key={fielduuid + index}>
                    <div>
                      <DropdownSelectComponent
                        items={[]}
                        disabled
                        selectLabelValue={
                          getAttributeDisplayName(
                            filter,
                            props.attributesList
                          ) || filter.custom_attribute.custom_attribute_name
                        }
                      />
                      <div className='filter-row-bottom'>
                        <DropdownSelectComponent
                          items={[]}
                          disabled
                          selectLabelValue={parseOperatorLabel(
                            filter.custom_attribute.comparison
                          )}
                        />
                        <InputComponent
                          disabled
                          value={
                            filter.custom_attribute.ui_presentation ||
                            filter.custom_attribute.value
                          }
                          onChange={() => {}}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        } else if (item.hasOwnProperty('custom_attribute')) {
          return (
            <div className='filters' key={fielduuid}>
              <div className='existing-group-wrapper'>
                <div className='existing-filter-group-wrapper'>
                  <div className='existing-filter-row'>
                    <DropdownSelectComponent
                      items={[]}
                      disabled
                      selectLabelValue={
                        getAttributeDisplayName(item, props.attributesList) ||
                        item.custom_attribute.custom_attribute_name
                      }
                    />
                    <div className='filter-row-bottom'>
                      <DropdownSelectComponent
                        items={[]}
                        disabled
                        selectLabelValue={parseOperatorLabel(
                          item.custom_attribute.comparison
                        )}
                      />
                      <InputComponent
                        disabled
                        value={parseDisplayedValue(item)}
                        onChange={() => {}}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        } else {
          return <></>;
        }
      })}
    </div>
  );
};
